// The technical part of the entity approval process will work as follows:
// When a user requests approval, we check if there is already a record
// where the status is PENDING. IF not, create a new entity_approval record.
//
// Then when the admin wants to approve, we look for a pending record.
// The next time the user updates the page and requires approval, we will
// create a new approval record IF, only if there is no pending record.
//
// This is intentional to retain approval history

export enum EntityApprovalStatus {
  Pending,
  Approved,
  Rejected,
}